window.initTextImageAnimation ?? (() => {
    window.initTextImageAnimation = (section_id) => {

      const initPopElement = () => {

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 1
        });

        document.querySelectorAll(`section#shopify-section-${section_id} .pop`).forEach(el => observer.observe(el));
    }

    initPopElement();

    const replaceTitleTMs = () => {
        document.querySelectorAll(`section#shopify-section-${section_id} .careline-20-text-image-copy .careline-20-title`).forEach((title) => {
            title.innerHTML = title.innerHTML.replace(
                /™/g,
                '<span class="tm">™</span>'
                );
        });
    }

    replaceTitleTMs();

    document.addEventListener('shopify:section:load', function () {
      initPopElement();
      replaceTitleTMs();
    });
}
  
})();
